import React, { useState } from 'react';
import { TextField, Button, Box } from '@mui/material';
import { BASE_URL } from '../constants';
// import { BASE_URL } from '../../constants';

function ProjectForm({ project, onSubmit, onCancel }) {
  const [name, setName] = useState(project ? project.name : '');
  const [area, setArea] = useState(project ? project.area : '');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ name, area });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} style={{ margin: '20px 0' }}>
      <TextField
        label="Project Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        fullWidth
        margin="normal"
        required
      />
      <TextField
        label="Area"
        value={area}
        onChange={(e) => setArea(e.target.value)}
        fullWidth
        margin="normal"
        required
      />
      <Box>
        <Button type="submit" variant="contained" color="primary" style={{ marginRight: '10px' }}>
          {project ? 'Update' : 'Add'} Project
        </Button>
        <Button variant="outlined" color="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
}

export default ProjectForm;